// src/routes/airlinesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Airlines from '../pages/airlines/Airlines';
import CreateAirline from '../pages/airlines/CreateAirline';
import EditAirline from '../pages/airlines/EditAirline';
import AirlineDetails from '../pages/airlines/AirlineDetails';
import ProtectedRoute from '../components/global/ProtectedRoute';

const airlinesRoutes = (
    <>
        {/* Airlines List */}
        <Route
            path="/airlines"
            element={
                <ProtectedRoute requiredPermission="airlines_list">
                    <Airlines />
                </ProtectedRoute>
            }
        />

        {/* Airlines Archive */}
        <Route
            path="/airlines/archive"
            element={
                <ProtectedRoute requiredPermission="airlines_archive_list">
                    <Airlines />
                </ProtectedRoute>
            }
        />

        {/* Create Airline */}
        <Route
            path="/airlines/create"
            element={
                <ProtectedRoute requiredPermission="airlines_create">
                    <CreateAirline />
                </ProtectedRoute>
            }
        />

        {/* Edit Airline */}
        <Route
            path="/airlines/:id/edit"
            element={
                <ProtectedRoute requiredPermission="airlines_edit">
                    <EditAirline />
                </ProtectedRoute>
            }
        />

        {/* Show Airline */}
        <Route
            path="/airlines/:id"
            element={
                <ProtectedRoute requiredPermission="airlines_show">
                    <AirlineDetails />
                </ProtectedRoute>
            }
        />
    </>
);

export default airlinesRoutes;
